/**
 * A role for web only: `webRole(web, native)` is `web` here and `native` (by
 * default none) on native, from `web-role.native.ts`. For a component whose
 * web markup needs a role that native already expresses another way, such as
 * a labelled container that must be a `group` on web while native keeps its
 * static-text trait.
 */
export function webRole<T extends string>(web: T, _native?: T): T | undefined {
  return web;
}

/**
 * A value for web only: `webOnly(value)` is `value` here and `undefined` on
 * native, from `web-role.native.ts`. For a prop native should leave unset,
 * such as a label that only a grouped native element could read.
 */
export function webOnly<T>(value: T): T | undefined {
  return value;
}

/**
 * A value for iOS and Android only: `nativeOnly(value)` is `undefined` here and
 * `value` on native, from `web-role.native.ts`. For a prop web should leave
 * unset, such as hiding an element that native would otherwise make a stop
 * of its own.
 */
export function nativeOnly<T>(_value: T): T | undefined {
  return undefined;
}
